var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDetailsTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.02,
    height: 22.02,
    viewBox: "0 0 22.02 22.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trophy",
    d: "M28.447,11.146H26.875V9.573A1.575,1.575,0,0,0,25.3,8H12.719a1.575,1.575,0,0,0-1.573,1.573v1.573H9.573A1.575,1.575,0,0,0,8,12.719v3.932a3.937,3.937,0,0,0,3.932,3.932h.8a7.856,7.856,0,0,0,5.49,3.106V25.3H15.864a2.362,2.362,0,0,0-2.359,2.359v1.573a.786.786,0,0,0,.786.786h9.437a.786.786,0,0,0,.786-.786V27.661A2.362,2.362,0,0,0,22.156,25.3H19.8V23.689a7.856,7.856,0,0,0,5.49-3.106h.8a3.937,3.937,0,0,0,3.932-3.932V12.719A1.575,1.575,0,0,0,28.447,11.146ZM22.942,27.661v.786H15.078v-.786a.787.787,0,0,1,.786-.786h6.292A.787.787,0,0,1,22.942,27.661ZM9.573,16.651V12.719h1.573v3.146A7.812,7.812,0,0,0,11.8,19,2.356,2.356,0,0,1,9.573,16.651Zm9.437,5.505a6.3,6.3,0,0,1-6.292-6.292V9.573H25.3v6.292A6.3,6.3,0,0,1,19.01,22.156Zm9.437-5.505A2.356,2.356,0,0,1,26.22,19a7.815,7.815,0,0,0,.655-3.132V12.719h1.573Z",
    transform: "translate(-8 -8)",
    fill: "#40eefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDetailsTrophy);
export default __webpack_public_path__ + "static/media/forum-details-Trophy.6dbea94c9f25948ff7e0af739ea22004.svg";
export { ForwardRef as ReactComponent };